export const experienceData = [
  {
    id: 1,
    company: "vHubs Company",
    jobtitle: "Frontend Developer",
    startYear: "10-2024",
    endYear: "present",
  },
  {
    id: 2,
    company: "BEDO Innovating Company",
    jobtitle: "MERN Stack Developer",
    startYear: "8-2023",
    endYear: "9-2024",
  },
  {
    id: 3,
    company: "Al Tawasol Company",
    jobtitle: "Frontend Developer",
    startYear: "1-2023",
    endYear: "7-2023",
  },

  //   {
  //     id: 3,
  //     company: "Vehement Capital Partners",
  //     jobtitle: "Backend Developer",
  //     startYear: "2019",
  //     endYear: "2020",
  //   },
];

